import {
  ShowContextProvider,
  SimpleShowLayout,
  TextField,
  Labeled,
  useEditController,
  RichTextField,
} from "react-admin";
import { useParams } from "react-router-dom";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";

export const MailTemplateShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "mail-templates/crud",
    id,
  });
  return (
    <ShowContextProvider value={controller}>
      <SimpleShowLayout className="RaShowClass">
        <PageTopBreadcrumb
          title="Template de E-mail"
          firstPath="/#/mail-templates/crud"
          secondTitle="Visualizando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="edit"
        />
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          <CardHeader title="Template de E-mail" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <Stack>
                  <Labeled>
                    <TextField source="id" />
                  </Labeled>
                  <Labeled>
                    <TextField source="name" label="Nome" />
                  </Labeled>
                  <Labeled>
                    <TextField source="trigger" label="Gatilho" />
                  </Labeled>
                  <Labeled>
                    <TextField source="subject" label="Assunto" />
                  </Labeled>
                  <div className="richTextBody">
                    <Labeled>
                      <RichTextField source="body" label="Corpo" />
                    </Labeled>
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleShowLayout>
    </ShowContextProvider>
  );
};
